import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import UserLogsTable from './components/UserLogsTable'
import { apiGetUserLogs } from '../../redux/api'
import { useIntl } from 'react-intl'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../setup'
import clsx from 'clsx'

const UserLogsPage: React.FC = () => {
  const intl = useIntl()

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [userLogs, setUserLogs] = useState<any>([])
  const [itemsPerPage, setItemsPerPage] = useState<any>(10)
  const [pageCount, setPageCount] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [offset, setOffset] = useState<number>(1);
  const [sorting, setSorting] = useState<any>({ col: null, order: null });

  const customer: any = useSelector<RootState>(
    ({ device }) => device.customer,
    shallowEqual
  )

  const getUserLogs = (customer: any, offset = 1, itemsPerPage: number, orderBy?: string, order?: string) => {

    const data: any = {
      customer: customer.Id,
      limit: itemsPerPage,
      offset,
    };

    if (orderBy && order) {
      data['sort-direction'] = order;
      data['sort-property'] = orderBy;
    }

    setUserLogs([]);
    setIsLoading(true);

    apiGetUserLogs(data)
      .then(({ data }: any) => {
        if (data.status === 200) {
          const totalPages = Math.ceil(data.response.TotalResults / data.response.PageSize);
          setUserLogs(data.response.Results || []);
          setPageCount(totalPages);
          setCurrentPage(offset - 1);
        } else {
          setUserLogs([]);
          toast.error(intl.formatMessage({ id: 'TOAST.ERROR_WHILE_REQUESTING_USER_LOGS' }));
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        setUserLogs([]);
        toast.error(intl.formatMessage({ id: 'TOAST.ERROR_WHILE_REQUESTING_USER_LOGS' }));
      });
  };

  const handlePageClick = (event: { selected: number }) => {
    const selectedPage = event.selected + 1;
    getUserLogs(customer, selectedPage, itemsPerPage);
  };

  useEffect(() => {
    if (customer && Object.keys(customer).length > 0 && offset >= 0 && itemsPerPage > 0) {
      getUserLogs(customer, offset, itemsPerPage);
    }
  }, [offset, itemsPerPage, customer]);

  return (
    <React.Fragment>
      <div className={`card`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-10'>
          <h1 className='align-items-start d-flex flex-column'>
            <span className='card-label fw-bolder text-primary mb-5'>{intl.formatMessage({ id: 'MENU.USER_LOGS' })}</span>
          </h1>

          {!isLoading && userLogs && userLogs.length > 0 && (

            <div className='d-flex grow w-100 align-items-center'>
              <div className='d-flex position-relative my-1 ml-auto'>
                <ul className='pagination ml-8'>
                  <li className={clsx('page-item', { active: itemsPerPage == 10 })}>
                    <button
                      type='button'
                      className='page-link'
                      onClick={(e) => {
                        setItemsPerPage(10)
                      }}
                      aria-label='10'
                    >
                      10
                    </button>
                  </li>
                  <li className={clsx('page-item', { active: itemsPerPage == 25 })}>
                    <button
                      type='button'
                      className='page-link'
                      onClick={(e) => {
                        setItemsPerPage(25)
                      }}
                      aria-label='25'
                    >
                      25
                    </button>
                  </li>
                  <li className={clsx('page-item', { active: itemsPerPage == 50 })}>
                    <button
                      type='button'
                      className='page-link'
                      onClick={(e) => {
                        setItemsPerPage(50)
                      }}
                      aria-label='50'
                    >
                      50
                    </button>
                  </li>
                  <li className={clsx('page-item', { active: itemsPerPage == 100 })}>
                    <button
                      type='button'
                      className='page-link'
                      onClick={(e) => {
                        setItemsPerPage(100)
                      }}
                      aria-label='100'
                    >
                      100
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          )}

        </div>
        {!isLoading && userLogs && userLogs.length > 0 && (
          <UserLogsTable
            userLogs={userLogs}
            // listView={listView}
            currentPage={currentPage}
            handlePageClick={handlePageClick}
            pageCount={pageCount}
            setSorting={setSorting}
            getUserLogs={getUserLogs}
            sorting={sorting}
            isLoading={isLoading}
            itemsPerPage={itemsPerPage}
          />
        )}
      </div>
    </React.Fragment>
  )
}
export default UserLogsPage
